import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings")({
  pendingComponent: PagePending,
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Listings",
  }),
});
